import React from "react";
import { Link } from "react-router-dom";
import { Container } from "../components/Grid";

function NoMatch() {
  return (
    <main>
      <Container>
        <section className="text-center" aria-labelledby="not-found-title">
          <h1 id="not-found-title">Page not found</h1>
          <p>The adventure page you requested does not exist.</p>
          <Link className="btn special" to="/">Return home</Link>
        </section>
      </Container>
    </main>
  );
}

export default NoMatch;
